import type { EntityConfig } from '../types'

export const authorizationEntity: EntityConfig = {
  name: 'authorization',
  displayName: 'Authorization',
  pluralName: 'Authorizations',
  status: {
    field: 'status',
    options: [
      { value: 'approved', label: 'Approved', color: 'success' },
      { value: 'declined', label: 'Declined', color: 'error' },
      { value: 'referred', label: 'Referred', color: 'warning' },
      { value: 'reversed', label: 'Reversed', color: 'info' },
      { value: 'timed_out', label: 'Timed Out', color: 'neutral' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Approved', value: 'approved' },
      { label: 'Declined', value: 'declined' },
      { label: 'Referred', value: 'referred' },
      { label: 'Reversed', value: 'reversed' },
      { label: 'Timed Out', value: 'timed_out' },
    ],
    mappings: {
      all: ['approved', 'declined', 'referred', 'reversed', 'timed_out'],
      approved: ['approved'],
      declined: ['declined'],
      referred: ['referred'],
      reversed: ['reversed'],
      timed_out: ['timed_out'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    network: { field: 'network', type: 'select', label: 'Network' },
  },
  uiFilterFields: ['status', 'network'],
}
